import { UiTypes } from "state/types/UiTypes";

export const UiReducer = (state = {}, action) => {
  let alerts;

  switch (action.type) {
    // RECAPTCHA
    // ------------------------------------------------------------------
    case UiTypes.recaptchaSet:
      return Object.assign({}, state, {
        recaptcha: action.recaptcha
      });

    case UiTypes.recaptchaUnset:
      return Object.assign({}, state, {
        recaptcha: null
      });

    case UiTypes.recaptchaRequest:
      return Object.assign({}, state, {
        recaptchaRequest: action.recaptchaRequest
      });

    // LOADER
    // ------------------------------------------------------------------
    case UiTypes.loaderHide:
    case UiTypes.loaderShow:
      return Object.assign({}, state, {
        loader: Object.assign({}, state.loader, action.ui.loader)
      });

    // MENU
    // ------------------------------------------------------------------

    case UiTypes.menuHide:
    case UiTypes.menuShow:
      return Object.assign({}, state, {
        menu: Object.assign({}, state.menu, action.ui.menu)
      });

    // NOTIFS
    // ------------------------------------------------------------------
    case UiTypes.notificationsHide:
    case UiTypes.notificationsShow:
      return Object.assign({}, state, {
        notifs: Object.assign(
          {}, 
          state.notifs, 
          action.ui.notifs
        )
      });

    // ALERTS
    // ------------------------------------------------------------------
    case UiTypes.alertClearAll:
      return Object.assign({}, state, {
        alerts: []
      });

    case UiTypes.alertPublish:
      alerts = [].concat(state.alerts, [action.alert]);
      alerts = alerts.filter(item => {
        return item !== null;
      });
      return Object.assign({}, state, {
        alerts
      });

    case UiTypes.alertRemove:
      alerts = [].concat(state.alerts);
      alerts = alerts.filter(item => {
        if (!item) return false;
        return item.id !== action.alertId
      });

      return Object.assign({}, state, {
        alerts
      });

    // QUEUE
    // ------------------------------------------------------------------
    case UiTypes.queue:
        let queue = state.queue;

        if (!queue.includes(action.queueId)) {
          queue.push(action.queueId);
        }

        return Object.assign({}, state, {
          queue: queue
        })

    case UiTypes.dequeue:
      let filteredQueue = state.queue.filter(item => {
        return (item !== action.queueId);
      });

      return Object.assign({}, state, {
        queue: filteredQueue
      })

    case UiTypes.clearQueue:
      return Object.assign({}, state, {
        queue: []
      });
    
    case UiTypes.beautyProfileToggle:
      return Object.assign({}, state, {
        beautyProfile: !state.beautyProfile
      });

    default:
      return Object.assign({}, state, action.ui);
  }
};

